import React, {useContext} from "react";
import {useProjectId} from "../ProjectName";
import {TableContext} from "../../../../misc/scroller/Table";
import {useNavigate} from "react-router-dom";
import {buildFilterLink} from "../../../../misc/scroller/Filter";
import {logisticsTableName} from "../logistics/Logistics";
import {Div10Row} from "../../../../api/QuoteDiv10";
import {removeRowOption, RowOptions} from "../../../logistics/purchasing/RowOptions";

export function RowActions(props: {
    row: Div10Row
}) {
    const project = useProjectId();
    const nav = useNavigate();
    const tbl = useContext(TableContext);

    return <RowOptions<Div10Row> draggable options={[
        {
            name: "View in Logistics",
            onClick: (input) => {
                input.onClose();
                nav(`/project/${project}/shop-drawing/logistics/div10?${buildFilterLink({
                    tableName: logisticsTableName(project, "div10"),
                    filter: {
                        type: "eq",
                        search: {
                            roomName: props.row.room,
                        },
                    }
                })}`);
            },
        },
        Object.assign(removeRowOption(props.row, {
            refreshTables: [],
            confirm: true,
            onComplete: () => tbl.reload(false),
        }), {
            name: "Archive",
        }),
    ]} />
}
